<template>
  <div class="child-view">
    <!-- <div>
      <van-sticky>
        <van-search v-model="filters.name"
          placeholder="请选择服务机构"
          @click="soIdShow = true"
          readonly="readonly"
          shape="round"
          background="#F2F2F2"
          left-icon="http://jmylapi.zhsq.cloud//upload/files/2022/11/ZR2uIACzwrnj6968bb9baa4a2b20d6e27daf88a25a15.png">
        </van-search>
        <van-popup v-model="soIdShow"
          position="bottom"
          get-container="body">
          <van-picker show-toolbar
            :columns="soIdList"
            value-key="Name"
            @cancel="soIdShow = false"
            @confirm="onSoId">
          </van-picker>
        </van-popup>
      </van-sticky>
    </div> -->
    <div class="box">
      <van-row gutter="10">
        <van-col span="12">
          <div class="boxTj"
            style="background: #1cc09f;">
            <div>
              计步
              <div style="margin-top:5px;font-weight: 550;font-size: 20px;">
                {{xinlvList[0].step}}
              </div>
            </div>
            <div class="oldmanImg">
              <img src="https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1694770253445.jpg" />
            </div>

          </div>
        </van-col>
        <van-col span="12">
          <div class="boxTj"
            style="background: #63a3df;">
            <div>
              <span>心率</span>
              <div style="margin-top:5px;font-weight: 550;font-size: 20px;">
                {{xinlvList[0].heartRate}}
              </div>
            </div>

            <div class="oldmanImg">
              <img src="https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1694770275168.jpg" />
            </div>
          </div>
        </van-col>
      </van-row>
      <van-row gutter="10"
        style="margin-top:10px;">
        <van-col span="12">
          <div class="boxTj"
            style="background: #e6a548;">
            <div>
              <div>血氧(%)</div>
              <div style="margin-top:5px;font-weight: 550;font-size: 20px;">
                {{xueyang}}
              </div>
            </div>
            <div class="oldmanImg">
              <img src="https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1694770312607.jpg" />
            </div>

          </div>
        </van-col>
        <van-col span="12">
          <div class="boxTj"
            style="background: #fb5651;">
            <div>
              <span>体温记录(℃)</span>
              <div style="margin-top:5px;font-weight: 550;font-size: 20px;">
                {{tiwen}}
              </div>
            </div>

            <div class="oldmanImg">
              <img src="https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1694770348511.png" />
            </div>
          </div>
        </van-col>
      </van-row>

      <van-row gutter="10"
        style="margin-top:10px;">
        <van-col span="12">
          <div class="boxTj"
            style="background: #df77d8;">
            <div>
              睡眠(小时)
              <div style="margin-top:5px;font-weight: 550;font-size: 20px;">
                {{shuimian}}
              </div>
            </div>
            <div class="oldmanImg">
              <img src="https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1694770385884.jpg" />
            </div>

          </div>
        </van-col>
        <van-col span="12">
          <div class="boxTj"
            style="background: #495a6b;">
            <div>
              <span>预警</span>
              <div style="margin-top:5px;font-weight: 550;font-size: 20px;">
                {{messageList.length}}
              </div>
            </div>

            <div class="oldmanImg">
              <img src="https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1694770408895.jpg" />
            </div>
          </div>
        </van-col>
      </van-row>
    </div>
    <!-- 计步 -->
    <div class="box"
      style="background:white;padding: 10px 0 ;">
      <div style="margin:5px 10px;">
        <div class="biankuang1"></div>
        <div class="title">
          计步
        </div>
      </div>
      <div style="width: 95%; margin: 10px auto">
        <div id="jibuCard"
          ref="jibuCard"
          style="width: 100%; height: 250px;"></div>
      </div>
    </div>
    <div class="box"
      style="background:white;padding: 10px 0 ;">
      <div>
        <div style="margin:5px 10px;">
          <div class="biankuang1"></div>
          <div class="title">
            体温
          </div>
        </div>

        <div style="width: 95%; margin: 10px auto">
          <div id="tiWenCard"
            ref="tiWenCard"
            style="width: 100%; height: 380px;"></div>
        </div>
      </div>
    </div>
    <div class="box"
      style="background:white;padding: 10px 0 ;">
      <div>
        <div style="margin:5px 10px;">
          <div class="biankuang1"></div>
          <div class="title">
            心率
          </div>
        </div>

        <div style="width: 95%; margin: 10px auto">
          <div id="xinlvCard"
            ref="xinlvCard"
            style="width: 100%; height: 380px;"></div>
        </div>
      </div>
    </div>
    <div class="box"
      style="background:white;padding: 10px 0 ;">
      <div>
        <div style="margin:5px 10px;">
          <div class="biankuang1"></div>
          <div class="title">
            血压
          </div>
        </div>

        <div style="width: 95%; margin: 10px auto">
          <div id="xueyaCard"
            ref="xueyaCard"
            style="width: 100%; height: 380px;"></div>
        </div>
      </div>
    </div>
    <div class="box"
      style="background:white;padding: 10px 0 ;">
      <div>
        <div style="margin:5px 10px;">
          <div class="biankuang1"></div>
          <div class="title">
            血氧
          </div>
        </div>

        <div style="width: 95%; margin: 10px auto">
          <div id="xueyangCard"
            ref="xueyangCard"
            style="width: 100%; height: 380px;"></div>
        </div>
      </div>
    </div>
    <div class="box"
      style="background:white;padding: 10px 0 ;">
      <div>
        <div style="margin:5px 10px;">
          <div class="biankuang1"></div>
          <div class="title">
            睡眠
          </div>
        </div>

        <div style="width: 95%; margin: 10px auto">
          <div id="shuimianCard"
            ref="shuimianCard"
            style="width: 100%; height: 380px;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
// import config from "@/config";
import wx from "weixin-js-sdk";
import { Dialog } from 'vant';
import Vue from 'vue';
import { Toast } from 'vant';
import { getToken, setToken } from "@/utils/auth";
import {
  heartRate,
  getHealthData,
  getTemperatureByIMEI,
  getStep,
  getHealthByType,
  getTemperatureHistory,
  getSleepData,
  getNewTrack,
  excdeptionListWhitoutCode,
  ExceptionMessage,
  temperature,
  bloodPressure,
  bloodOxygen,
} from "@/api/Lycal";
Vue.use(Toast);
export default {
  data () {
    return {
      filters: {
        IMEI: "",
        StartTime: "2023-09-15",
        EndTime: "2023-09-16",
        TimeOffset: 8,
      },
      BloodOxygenItems: [], //血氧数据
      BloodPressureItems: [], //血压数据
      HealthRatio: [], //血压数据比例
      HeartItems: [], //心率数据
      Items: [], //健康数据
      SleepItems: [], //睡眠数据
      SleepRatio: {}, //睡眠数据比例
      StepCount: 0, //步数数据
      BloodSugarItems: [], //血糖数据
      tiwen: 0, //体温
      newDate: "", //当前时间
      shuimian: 0, //睡眠
      currentDate: new Date(),
      dates7: [],
      newDateTime: "",
      xueyang: "",
      xinlvList: [{ step: 0, heartRate: 0 }], //心率列表
      xueyangList: [{ bloodOxygen: 0 }], //血氧列表
      coordinate: {}, //定位
      messageList: [], //预警信息列表
    }
  },
  created () {
    setToken(this.$route.query["token"]);
    this.snId = this.$route.query["sn"]
    this.getHeartRate()
    this.getTemperature();
    this.getBloodPressure();
    this.getBloodOxygen();
  },
  methods: {
    // 获取心率步数睡眠数据
    getHeartRate () {
      heartRate({
        imei: this.snId,
        startTime: this.newDate,
        end: this.newDate,
      }).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          if (res.data.data.length == 0) {
            this.xinlvList = [
              {
                step: 0,
                heartRate: 0,
                deepSleep: 0,
                lightSleep: 0,
                time: this.newDate + " 00:00:00",
              },
            ];
            this.getHeartItems();
            this.sleepCount();
            this.getStepStat();
          } else {
            this.xinlvList = res.data.data;
            this.getHeartItems();
            this.sleepCount();
            this.getStepStat();
          }
        }
      });
    },


    // 服务趋势
    getWorkOrderTrend () {
      WOTrendOfSO({ soId: this.filters.soId }).then((res) => {
        var list = res.data;
        if (list.code == 0) {
          var StatDay = [];
          var OrderCount = [];
          for (let i = 0; i < list.data.length; i++) {
            const e = list.data[i];
            if (e.SOId == this.filters.soId) {
              for (let i = 0; i < e.Detail.length; i++) {
                const b = e.Detail[i];
                StatDay.push(b.SOName);
                OrderCount.push(b.StatDate);
              }
              this.getTxTongJi(StatDay, OrderCount);
            }
          }

        }
      });
    },
    // 步数统计
    getStepStat () {
      var timeDay = [];
      var count = [];
      let width = document.getElementById("jibuCard").clientWidth;
      let height = document.getElementById("jibuCard").clientHeight;
      for (let index = 0; index < this.xinlvList.length; index++) {
        const e = this.xinlvList[index];
        // timeDay.push(this.newDate + ' ' + e.Hour + ':00');
        timeDay.push(e.time);
        count.push(e.step);
      }
      this.charts = this.$echarts.init(document.getElementById("jibuCard"));
      this.charts.resize(width, height);
      this.charts.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
              backgroundColor: "#333",
            },
          },
        },
        grid: {
          right: "10%",
          bottom: "15%",
          left: "2%",
          top: "10%",
          containLabel: true,
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            height: 10,
            left: "10%",
            right: "10%",
            bottom: "10%",
            start: 60,
            end: 100,
            textStyle: {
              color: "#495a6b",
              fontSize: 11,
            },
          },
          {
            type: "inside",
          },
        ],
        xAxis: [
          {
            type: "category",
            data: timeDay,
            name: "",
            nameTextStyle: {
              color: "#495a6b",
            },
            axisLine: {
              lineStyle: {
                color: "#eaecf2",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#495a6b",
                fontSize: 12,
              },
              formatter: function (params) {
                return params.split(" ")[0] + "\n" + params.split(" ")[1];
              },
              //interval:0,
              //rotate:30
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            nameTextStyle: {
              color: "#495a6b",
            },
            position: "left",
            axisLine: {
              lineStyle: {
                color: "#495a6b",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#eaecf2",
              },
            },
            axisLabel: {
              color: "#495a6b",
              fontSize: 12,
            },
          },
        ],
        series: [
          {
            name: "步数",
            type: "line",
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#50b432",
              },
            },
            data: count,
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#495a6b",
              },
            },
          },
        ],
      });
    },
    // 获取体温
    getTemperature () {
      temperature({
        imei: this.snId,
        startTime: this.newDate,
        end: this.newDate,
      }).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data[0].value) {
            this.tiwen = JSON.parse(res.data.data[0].value).temperature;
          }
          this.getTiWenItems(res.data.data);
        }
      });
    },
    // 体温统计
    getTiWenItems (val) {
      var timeDay = [];
      var count = [];

      for (let index = 0; index < val.length; index++) {
        const e = val[index];
        timeDay.push(e.terminalTime);
        count.push(JSON.parse(e.value).temperature);
      }
      if (val.length > 10) {
        var start = 90;
      } else {
        var start = 20;
      }
      this.charts = this.$echarts.init(document.getElementById("tiWenCard"));
      this.charts.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
              backgroundColor: "#333",
            },
          },
          formatter: function (e) {
            var str =
              e[0].name +
              "<br>" +
              "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#70ca5c;'></span>" +
              "" +
              e[0].seriesName +
              " : " +
              e[0].value +
              "℃";
            return str;
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            height: 10,
            left: "10%",
            right: "10%",
            bottom: "10%",
            start: start,
            end: 100,
            textStyle: {
              color: "#495a6b",
              fontSize: 11,
            },
          },
          {
            type: "inside",
          },
        ],
        grid: {
          right: "5%",
          bottom: "15%",
          left: "2%",
          top: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: timeDay,
            name: "",
            nameTextStyle: {
              color: "#495a6b",
            },
            axisLine: {
              lineStyle: {
                color: "#eaecf2",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#495a6b",
                fontSize: 12,
              },
              formatter: function (params) {
                return params.split(" ")[0] + "\n" + params.split(" ")[1];
              },
              //interval:0,
              //rotate:30
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "℃",
            nameTextStyle: {
              color: "#495a6b",
            },
            position: "left",
            axisLine: {
              lineStyle: {
                color: "#495a6b",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#eaecf2",
              },
            },
            axisLabel: {
              color: "#495a6b",
              fontSize: 12,
            },
          },
        ],
        series: [
          {
            name: "体温",
            type: "line",
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#50b432",
              },
            },
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#50b432",
              },
            },
            data: count,
          },
        ],
      });
    },

    // 心率统计
    getHeartItems () {
      // console.log(this.HeartItems);
      var timeDay = [];
      var count = [];
      let width = document.getElementById("xinlvCard").clientWidth;
      let height = document.getElementById("xinlvCard").clientHeight;
      for (let index = 0; index < this.xinlvList.length; index++) {
        const e = this.xinlvList[index];
        timeDay.push(e.time);
        count.push(e.heartRate);
      }
      this.charts = this.$echarts.init(document.getElementById("xinlvCard"));
      this.charts.resize(width, height);
      this.charts.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
              backgroundColor: "#333",
            },
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            height: 10,
            left: "10%",
            right: "10%",
            bottom: "10%",
            start: 60,
            end: 100,
            textStyle: {
              color: "#495a6b",
              fontSize: 11,
            },
          },
          {
            type: "inside",
          },
        ],
        grid: {
          right: "5%",
          bottom: "15%",
          left: "2%",
          top: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: timeDay,
            name: "",
            nameTextStyle: {
              color: "#495a6b",
            },
            axisLine: {
              lineStyle: {
                color: "#eaecf2",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#495a6b",
                fontSize: 12,
              },
              formatter: function (params) {
                return params.split(" ")[0] + "\n" + params.split(" ")[1];
              },
              //interval:0,
              //rotate:30
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            nameTextStyle: {
              color: "#495a6b",
            },
            position: "left",
            axisLine: {
              lineStyle: {
                color: "#495a6b",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#eaecf2",
              },
            },
            axisLabel: {
              color: "#495a6b",
              fontSize: 12,
            },
          },
        ],
        series: [
          {
            name: "心率",
            type: "line",
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#da3a3a",
              },
            },
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#495a6b",
              },
            },
            data: count,
          },
        ],
      });
    },

    // 获取血压数据
    getBloodPressure () {
      bloodPressure({
        imei: this.snId,
        startTime: this.newDate,
        end: this.newDate,
      }).then((res) => {
        if (res.data.code == 0) {
          // console.log(res.data);
          this.BloodPressureItems = res.data.data;
          this.getBloodPressureItems();
        }
      });
    },
    // 血压统计
    getBloodPressureItems () {
      // console.log(this.HeartItems);
      var timeDay = [];
      var diastolic = [];
      var shrink = [];
      let width = document.getElementById("xueyaCard").clientWidth;
      let height = document.getElementById("xueyaCard").clientHeight;
      for (let index = 0; index < this.BloodPressureItems.length; index++) {
        const e = this.BloodPressureItems[index];
        timeDay.push(e.terminalTime.replace("T", " "));
        const bloodOxygen = JSON.parse(e.value);

        diastolic.push(bloodOxygen.diastolic);
        shrink.push(bloodOxygen.systolic);
      }
      this.charts = this.$echarts.init(document.getElementById("xueyaCard"));
      this.charts.resize(width, height);
      this.charts.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
              backgroundColor: "#333",
            },
          },
          formatter: function (e) {
            var str =
              e[0].name +
              "<br>" +
              "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#da3a3a;'></span>" +
              "" +
              e[0].seriesName +
              " : " +
              e[0].value +
              "mmHg<br>" +
              "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#e6a548'></span>" +
              "" +
              e[1].seriesName +
              " : " +
              e[1].value +
              "mmHg";
            return str;
          },
        },
        legend: {
          x: "right",
          textStyle: {
            color: "#495a6b",
            fontSize: 13,
          },
          icon: "circle",
          data: ["收压缩", "舒张缩"],
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            height: 10,
            left: "10%",
            right: "10%",
            bottom: "10%",
            start: 60,
            end: 100,
            textStyle: {
              color: "#495a6b",
              fontSize: 11,
            },
          },
          {
            type: "inside",
          },
        ],
        grid: {
          right: "5%",
          bottom: "15%",
          left: "5%",
          top: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: timeDay,
            name: "",
            nameTextStyle: {
              color: "#495a6b",
            },
            axisLine: {
              lineStyle: {
                color: "#eaecf2",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#495a6b",
                fontSize: 12,
              },
              formatter: function (params) {
                return params.split(" ")[0] + "\n" + params.split(" ")[1];
              },
              //interval:0,
              //rotate:30
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "mmHg",
            nameTextStyle: {
              color: "#495a6b",
            },
            position: "left",
            axisLine: {
              lineStyle: {
                color: "#495a6b",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#eaecf2",
              },
            },
            axisLabel: {
              color: "#495a6b",
              fontSize: 12,
            },
          },
        ],
        series: [
          {
            name: "收压缩",
            type: "line",
            symbol: "circle",
            yAxisIndex: 0,
            symbolSize: 5,
            itemStyle: {
              normal: {
                color: "#da3a3a",
              },
            },
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#da3a3a",
              },
            },
            data: diastolic,
          },
          {
            name: "舒张缩",
            type: "line",
            symbol: "circle",
            yAxisIndex: 0,
            symbolSize: 5,
            itemStyle: {
              normal: {
                color: "#e6a548",
              },
            },
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#e6a548",
              },
            },
            data: shrink,
          },
        ],
      });
    },

    // 获取血氧数据
    getBloodOxygen () {
      bloodOxygen({
        imei: this.snId,
        startTime: this.newDate,
        end: this.newDate,
      }).then((res) => {
        if (res.data.code == 0) {
          this.BloodOxygenItems = res.data.data;
          if (res.data.data.length > 0) {
            this.xueyang = JSON.parse(res.data.data[0].value).bloodOxygen;
          }

          this.getBloodOxygenItems();
        }
      });
    },
    // 血氧统计
    getBloodOxygenItems () {
      var timeDay = [];
      var count = [];
      let width = document.getElementById("xueyangCard").clientWidth;
      let height = document.getElementById("xueyangCard").clientHeight;
      for (let index = 0; index < this.BloodOxygenItems.length; index++) {
        const e = this.BloodOxygenItems[index];
        timeDay.push(e.terminalTime.replace("T", " "));
        const bloodOxygen = JSON.parse(e.value).bloodOxygen;
        count.push(bloodOxygen);
      }
      this.charts = this.$echarts.init(document.getElementById("xueyangCard"));
      this.charts.resize(width, height);

      this.charts.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
              backgroundColor: "#333",
            },
          },
          formatter: function (e) {
            var str =
              e[0].name +
              "<br>" +
              "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#da3a3a;'></span>" +
              "" +
              e[0].seriesName +
              " : " +
              e[0].value +
              "%";
            return str;
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            height: 10,
            left: "10%",
            right: "10%",
            bottom: "10%",
            start: 60,
            end: 100,
            textStyle: {
              color: "#495a6b",
              fontSize: 11,
            },
          },
          {
            type: "inside",
          },
        ],
        grid: {
          right: "5%",
          bottom: "15%",
          left: "2%",
          top: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: timeDay,
            name: "",
            nameTextStyle: {
              color: "#495a6b",
            },
            axisLine: {
              lineStyle: {
                color: "#eaecf2",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#495a6b",
                fontSize: 12,
              },
              formatter: function (params) {
                return params.split(" ")[0] + "\n" + params.split(" ")[1];
              },
              //interval:0,
              //rotate:30
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            nameTextStyle: {
              color: "#495a6b",
            },
            position: "left",
            axisLine: {
              lineStyle: {
                color: "#495a6b",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#eaecf2",
              },
            },
            axisLabel: {
              color: "#495a6b",
              fontSize: 12,
            },
          },
        ],
        series: [
          {
            name: "血氧",
            type: "line",
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#da3a3a",
              },
            },
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#da3a3a",
              },
            },
            data: count,
          },
        ],
      });
    },

    // 睡眠统计
    sleepCount () {
      var timeDay = [];
      var deepSleepSec = [];
      var lightSleepSec = [];
      let width = document.getElementById("shuimianCard").clientWidth;
      let height = document.getElementById("shuimianCard").clientHeight;
      for (let index = 0; index < this.xinlvList.length; index++) {
        const e = this.xinlvList[index];
        timeDay.push(e.time);
        if (e.deepSleep != "0") {
          // console.log(e.deepSleep);
          const indexOfHour = e.deepSleep.indexOf("小时");
          const hour = e.deepSleep.slice(0, indexOfHour) * 60;
          const indexOfMin = e.deepSleep.indexOf("分钟");
          const min = e.deepSleep.slice(indexOfHour + 2, indexOfMin);
          const sumMin = hour + Number(min);
          // deepSleepSec.push(Math.floor(sumMin / 3600));
          deepSleepSec.push(sumMin);

          // deepSleepSec.push(e.deepSleep);
        } else {
          deepSleepSec.push(0);
        }
        if (e.lightSleep != "0") {
          // console.log(e.deepSleep);
          const indexOfHour = e.lightSleep.indexOf("小时");
          const hour = e.lightSleep.slice(0, indexOfHour) * 60;
          const indexOfMin = e.lightSleep.indexOf("分钟");
          const min = e.lightSleep.slice(indexOfHour + 2, indexOfMin);
          const sumMin = hour + Number(min);
          lightSleepSec.push(Math.floor(sumMin));

          // deepSleepSec.push(e.deepSleep);
        } else {
          lightSleepSec.push(0);
        }
        // lightSleepSec.push(Math.floor(e.lightSleep / 3600));
      }
      // console.log(deepSleepSec, lightSleepSec);
      this.charts = this.$echarts.init(document.getElementById("shuimianCard"));
      this.charts.resize(width, height);
      this.charts.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (e) {
            const hour1 = Math.floor(e[0].value / 60); // 计算小时数
            const min1 = e[0].value % 60; // 计算剩余的分钟数
            const hour2 = Math.floor(e[1].value / 60); // 计算小时数
            const min2 = e[1].value % 60; // 计算剩余的分钟数
            var str =
              e[0].name +
              "<br>" +
              "<span style='display:inline-block;margin-right:5px;border-radius:3px;width:10px;height:10px;background-color:#00d497;'></span>" +
              "" +
              e[0].seriesName +
              " : " +
              hour1 +
              "小时" +
              min1 +
              "分钟<br>" +
              "<span style='display:inline-block;margin-right:5px;border-radius:3px;width:10px;height:10px;background-color:#63a3df'></span>" +
              "" +
              e[1].seriesName +
              " : " +
              hour2 +
              "小时" +
              min2 +
              "分钟";
            return str;
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            height: 10,
            left: "10%",
            right: "10%",
            bottom: "10%",
            start: 60,
            end: 100,
            textStyle: {
              color: "#495a6b",
              fontSize: 11,
            },
          },
          {
            type: "inside",
          },
        ],
        legend: {
          x: "right",
          textStyle: {
            color: "#495a6b",
            fontSize: 13,
          },
          data: ["深睡", "浅睡"],
          right: 10,
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 35,
        },
        grid: {
          right: "5%",
          bottom: "15%",
          left: "2%",
          top: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: timeDay,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#eaecf2",
                width: 1,
                type: "solid",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#495a6b",
              },
              formatter: function (params) {
                return params.split(" ")[0] + "\n" + params.split(" ")[1];
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "分钟",
            axisLabel: {
              formatter: "{value}",
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#495a6b",
                width: 1,
                type: "solid",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#eaecf2",
              },
            },
          },
        ],
        series: [
          {
            name: "深睡",
            type: "bar",
            data: deepSleepSec,
            barWidth: 10, //柱子宽度
            barGap: 1, //柱子之间间距
            itemStyle: {
              normal: {
                color: "#00d497",
                opacity: 1,
              },
            },
          },
          {
            name: "浅睡",
            type: "bar",
            data: lightSleepSec,
            barWidth: 10,
            barGap: 1,
            itemStyle: {
              normal: {
                color: "#63a3df",
                opacity: 1,
              },
            },
          },
        ],
      });
    },
  }
}
</script>

<style scoped>
.child-view {
  min-height: 100%;
  background: #f5f5f5;
}
.box {
  width: 95%;
  margin: 10px auto;
}
.boxTj {
  background: #23d87b;
  height: 70px;
  border-radius: 5px;
  color: white;
  display: flex;
  justify-content: space-around;
  align-content: center;
  flex-wrap: wrap;
}
.boxTj div:first-child {
  width: 95px;
}
.oldmanImg {
  padding-top: 5px;
}
.oldmanImg img {
  /* padding-top: 5px; */
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 2px solid #fff;
}
.title {
  font-size: 16px;
  margin-left: 10px;
  line-height: 20px;
}
.biankuang1 {
  /* border-left: 4px solid #6182FA; */
  border: 2px solid #02c08f;
  background-color: #02c08f;
  width: 0;
  height: 17px;
  float: left;
  border-radius: 2px;
  /* margin: 0 8px; */
}
/deep/.van-tabbar-item__icon {
  font-size: 18px !important;
  margin-bottom: 5px !important;
}
</style>